var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-button',_vm._g(_vm._b({class:_vm.classes,attrs:{"no-reset":"","href":_vm.href,"type":!_vm.href ? 'button' : null}},'base-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }